<form [formGroup]="_registerForm" (ngSubmit)="register()" ridangoFocusInvalidInput>
    <ridango-form-field class="form-margin-10">
        <input
            [formControl]="_registerForm.controls.email"
            ridangoInput
            name="email"
            type="email"
            required
            ridangoUntouchOnFocusout />
        <ridango-label>{{ 'PH_EMAIL' | translate }}</ridango-label>
        <ridango-error
            *ngIf="
                _registerForm.controls.email.hasError('email') && !_registerForm.controls.email.hasError('required')
            ">
            {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
        </ridango-error>
        <ridango-error *ngIf="_registerForm.controls.email.hasError('required')">
            {{ 'LOCAL_INPUT_EMAIL_MISSING' | translate }}
        </ridango-error>
    </ridango-form-field>

    <ridango-form-field class="form-margin-10" *ngIf="registrationOptions.DISPLAY_FULL_NAME_FIELD">
        <input
            [formControl]="_registerForm.controls.name"
            ridangoInput
            name="name"
            type="name"
            required
            ridangoUntouchOnFocusout />
        <ridango-label>{{ 'PH_ACCOUNT_NAME' | translate }}</ridango-label>
        <ridango-error *ngIf="_registerForm.controls.name.hasError('required')">
            {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
        </ridango-error>
    </ridango-form-field>

    <ridango-form-field class="form-margin-10">
        <input
            [formControl]="_registerForm.controls.password"
            ridangoInput
            type="{{ _showPassword ? 'text' : 'password' }}"
            name="password"
            required
            ridangoUntouchOnFocusout />
        <ridango-label>{{ 'PH_PASSWORD' | translate }}</ridango-label>
        <a
            class="show-hide link link--action"
            (click)="togglePassword($event)"
            (keydown.enter)="togglePassword($event)"
            (keydown.space)="togglePassword($event)"
            tabindex="0"
            ridangoSuffix>
            {{ _showPassword ? ('HIDE' | translate) : ('SHOW' | translate) }}
        </a>
        <ridango-error
            *ngIf="
                (_registerForm.controls.password.touched &&
                    _registerForm.controls.password.hasError('numberRequired')) ||
                _registerForm.controls.password.hasError('minlength')
            ">
            {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
        </ridango-error>
    </ridango-form-field>

    <div class="item-tnc" *ngIf="_terms">
        <span class="checkbox-wcag">
            <input
                class="checkbox-wcag__checkbox"
                type="checkbox"
                attr.aria-hidden="true"
                formControlName="terms"
                required
                tabindex="-1"
                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}" />

            <span
                class="checkbox-wcag__checkmark"
                (click)="toggleCheckbox('terms')"
                (keydown.space)="toggleCheckbox('terms')"
                tabindex="0"
                attr.aria-checked="{{ _termsAgreed }}"
                role="checkbox"
                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}">
            </span>

            <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                <span>
                    <span
                        class="link-label"
                        (click)="toggleCheckbox('terms')"
                        (keydown.enter)="toggleCheckbox('terms')"
                        (keydown.space)="toggleCheckbox('terms')">
                        {{ 'READ_TERMS' | translate }}
                    </span>

                    <a
                        class="link link--emphasized link--action"
                        #modalTrigger
                        (click)="openTerms()"
                        (keydown.enter)="openTerms()"
                        (keydown.space)="openTerms()"
                        tabindex="0"
                        role="link">
                        {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}
                    </a>
                </span>
            </label>
        </span>
    </div>

    <div class="item-tnc" *ngIf="registrationOptions.CHECK_GDPR">
        <span class="checkbox-wcag">
            <input
                class="checkbox-wcag__checkbox"
                type="checkbox"
                attr.aria-hidden="true"
                formControlName="gdpr"
                required
                tabindex="-1"
                attr.aria-label="{{ 'GDPR_CHECKBOX_ARIA_LABEL' | translate }}" />

            <span
                class="checkbox-wcag__checkmark"
                (click)="toggleCheckbox('gdpr')"
                (keydown.space)="toggleCheckbox('gdpr')"
                tabindex="0"
                attr.aria-checked="{{ _gdprAgreed }}"
                role="checkbox"
                attr.aria-label="{{ 'GDPR_CHECKBOX_ARIA_LABEL' | translate }}">
            </span>

            <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                <span>
                    <span
                        class="link-label"
                        (click)="toggleCheckbox('gdpr')"
                        (keydown.enter)="toggleCheckbox('gdpr')"
                        (keydown.space)="toggleCheckbox('gdpr')">
                        {{ 'GDPR_TEXT' | translate }}
                    </span>

                    <a
                        class="link link--emphasized link--action"
                        href="{{ 'GDPR_LINK_URL' | translate }}"
                        target="_blank"
                        tabindex="0"
                        role="link">
                        {{ 'GDPR_LINK' | translate }}
                    </a>
                </span>
            </label>
        </span>
    </div>

    <button class="btn btn--maximal btn--primary btn--big" type="submit">
        {{ 'BTN_REGISTER' | translate }}
    </button>
</form>
